import React, { useState } from "react";
import "../css/label.css";
import "../css/customErrorForFields.css";
import "../css/customSearchDropdown.css"
import "../css/customLabelDropDown.css";
import Label from "./Label";
import { Select } from "antd";
import WarningIcon from "../../../../assets/warning.svg";
import LabelAndInputField from "./LabelAndInputField";
import searchIcon from "../../../../assets/Search-Icon.svg"
const { Option } = Select;

export default function CustomLabelDropdown({
  mdValue,
  lgValue,
  smValue,
  xsValue,
  labelText,
  isCompulsary,
  controlId,
  controlName,
  value,
  options = [],
  handleSelectChange,
  errorMessage,
  isDisabled,
  placeholder,
  isRequired,
  multiSelect = false,
  maxTagCount = "1",
  wrapperClass,
  showSearch = false,
  allowClear = true,
  style,
  ...props
}) {

  const  [searchText, setSearchText] = useState("");
  const hasError = Boolean(errorMessage);
  const  filteredOptions = showSearch && searchText
    ? options.filter((opt) =>
        opt.label.toLowerCase().includes(searchText.toLowerCase())
      )
    : options;
  return (

    <div style={style} className={`custom-field-wrapper ${wrapperClass || ""}`}>
      {/* Label Section */}
      {labelText && (
        <Label
          className={"custom-label"}
          labelText={labelText}
          isCompulsary={isCompulsary}
        />
      )}
      <Select
        id={controlId}
        name={controlName}
        value={hasError ? undefined : value || undefined}
        onChange={(val) => handleSelectChange(val)}
        disabled={isDisabled}
        placeholder={hasError ? errorMessage : placeholder}
        className={`custom-dropdown ${hasError ? "dropdown-error" : ""}`}
        size="large"
        mode={multiSelect ? "multiple" : undefined}
        maxTagCount={multiSelect ? maxTagCount : undefined}
        allowClear={allowClear}
        // options={options}
        optionFilterProp="children"
        dropdownClassName="custom-options-dropdown"
        getPopupContainer={(trigger) => trigger.parentNode}
        filterOption={false}
        {...props}

        dropdownRender={
          showSearch
            ? (menu) => (
                <div className="dropdown-wrapper">
                  <div
                    className="dropdown-search"
                    onKeyDown={(e) => e.stopPropagation()}
                  >
                    <LabelAndInputField
                      placeholder="Search..."
                      value={searchText}
                      handleInputChange={(e) => setSearchText(e.target.value)}
                      suffixIcon={<img src={searchIcon} alt="search" />}
                      autoFocus
                    />
                  </div>
                  <div className="custom-options-dropdown">{menu}</div>
                </div>
              )
            : undefined
        }

        suffixIcon={
          hasError ? (
            <img
              src={WarningIcon}
              alt="error"
              className="select-error-icon"
            />
          ) : undefined
        }

      >
        {filteredOptions.map((opt, index) => (
          <Option key={opt.value || index} value={opt.value}>
            {opt.label}
          </Option>
        ))}
      </Select>
    </div>
  );
}
